import {getIssues} from "../../api/issues";

const state = () => ({

    issues:'',
})


const getters = {
    get_issues(state) {
        return state.issues;
    },
}

const mutations = {
    SET_ISSUES(state,data){
        state.issues = data;
    }
}

const actions = {
    async fetchIssues({ commit },payload) {
        const response = await getIssues(payload);
        commit('SET_ISSUES', response.data);
    },

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
